import { render } from "./HzbaModalItemBlock.vue?vue&type=template&id=fa964570&scoped=true"
import script from "./HzbaModalItemBlock.vue?vue&type=script&lang=js"
export * from "./HzbaModalItemBlock.vue?vue&type=script&lang=js"

import "./HzbaModalItemBlock.vue?vue&type=style&index=0&id=fa964570&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa964570"]])

export default __exports__